import { render } from "./NoticiaFormModal.vue?vue&type=template&id=5ab263d0"
import script from "./NoticiaFormModal.vue?vue&type=script&lang=js"
export * from "./NoticiaFormModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__